import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// ── Reset scroll ke top saat initial load ─────────────────────────────────
// Mencegah browser restore scroll position saat refresh
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}
window.scrollTo(0, 0);

createRoot(document.getElementById("root")!).render(<App />);
